import { render, staticRenderFns } from "./data6.vue?vue&type=template&id=0fb88ea7&scoped=true&"
import script from "./data6.vue?vue&type=script&lang=js&"
export * from "./data6.vue?vue&type=script&lang=js&"
import style1 from "./data6.vue?vue&type=style&index=1&id=0fb88ea7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb88ea7",
  null
  
)

export default component.exports